import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldBase } from '../../core/form-field/form-field-base.directive';
import { SurveyQuestion } from '../../models';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
  selector: 'lib-survey-email-input',
  template: `<lib-input-base>
    <input
      type="email"
      class="form-control"
      [formControl]="control"
      placeholder="Adresse email"
    />
  </lib-input-base>`,
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputBaseComponent],
})
export class EmailInputComponent extends FormFieldBase {
  @Input({ required: true }) question!: SurveyQuestion;
}
